import axios from "axios";
import * as actionType from "../../constant/actionType";
export const GetOrgEmailLogs = (
  filtersort,
  filterorder,
  filterpage,
  filterlimit,
  searchTerm,
  organisation_id
) => {
  return (dispatch) => {
    // dispatch(GetallEmailLogsStart());
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));

    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/provider/GetOrgEmailLogs`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        
        organisationid: storedData?.organisation_id,
      },
      params: {
        search: searchTerm,
        page: filterpage,
        limit: filterlimit,
        sort: filtersort,
        order: filterorder,
        organisation_id: organisation_id,
      },
    };

    return axios(config)
      .then(function (response) {
        // dispatch(GetallEmailLogsSuccess(response.data));
        return response.data;
      })
      .catch(function (error) {
        // dispatch(
        //   GetallEmailLogsFail("Something went wrong, Please try again.")
        // );
        return error;
      });
  };
};
